import { useMemo } from 'react'
import { createTheme } from '@mui/material/styles'

import { typography } from '@hapana/shared/web/styles/material-ui/typography'
import { components } from '@hapana/shared/web/styles/material-ui/components/index'

import { palette, settings_palette } from '../../styles/material-ui/palette'
import { components as coreComponents } from '../../styles/material-ui/components'
import { breakpoints } from '../../styles/material-ui/breakpoints'
import useSiteStore from '../../stores/site.store'

// Demo public routes should always use brand palette regardless of site context
const DEMO_BRAND_PATHS = ['/signup', '/verify', '/creating', '/magic-link', '/login']
const isDemoBrandRoute = () => {
  const hostname = window.location.hostname
  const isDemoHost =
    hostname.split('.')[0] === 'demo' ||
    ((hostname === 'localhost' || hostname === '127.0.0.1') &&
      import.meta.env.VITE_DEMO_STAFF_TENANT_ID)
  if (!isDemoHost) {
    return false
  }
  return DEMO_BRAND_PATHS.some(
    (p) => window.location.pathname === p || window.location.pathname.startsWith(p + '/')
  )
}

export const useAppTheme = () => {
  const { currentSite } = useSiteStore()

  const currentTheme = useMemo(() => {
    const isLocationContext = !!currentSite && !isDemoBrandRoute()
    const currentPalette = isLocationContext ? settings_palette : palette

    const themeObject = createTheme({
      typography,
      palette: currentPalette,
      components: {
        ...components,
        ...coreComponents,
      },
      breakpoints,
    })

    return themeObject
  }, [currentSite])

  return currentTheme
}
